<template>
  <div class="portfolioStructure">
    <!--    <h2>Структура портфеля</h2>-->
    <div class="table__content">
      <div class="table__itemsHeader">
        <div class="table__itemsTitle">Наименование</div>
        <div class="table__itemsTitle">Доля, %</div>
        <div class="table__itemsTitle">Класс актива</div>
      </div>
      <div v-for="(el, key) in briefcaseInfo" :key="key" class="table__items">
        <div class="table__itemsText">{{ el.name }}</div>
        <div class="table__itemsText">{{ `${el["share"]}%` }}</div>
        <div class="table__itemsText">{{ el.active }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import { table } from "./table.js";

export default {
  name: "PortfolioStructure",
  props: ["briefcaseInfo"],
  data: () => {
    return {
      // table1: table
    };
  }
};
</script>

<style scoped>

</style>